import { priceForShopItem } from "../components/catalog-card-primitives";

import type { ShopItem } from "@/types/shop";

export interface PackagePricingSummary {
  price: number;
  savings: number;
}

/** Combines the package's built-in savings with its promotional discount. */
export const packagePricingSummary = (
  item: ShopItem,
): PackagePricingSummary => {
  const price = priceForShopItem(item);
  const packagePrice = item.originalPrice ?? item.price;
  const packageSavings = Math.max(0, item.packageSavings ?? 0);
  const promotionSavings = Math.max(0, packagePrice - price);

  return {
    price,
    savings: packageSavings + promotionSavings,
  };
};
